export const COD_PAIS_URU: string = 'UY';
export const COD_PAIS_ARG: string = 'AR';
export const COD_PAIS_US: string = 'US';
export const COD_PAIS_MX: string = 'MX';
export const COD_PAIS_BR: string = 'BR';
export const COD_PAIS_PE: string = 'PE';
export const COD_PAIS_PY: string = 'PY';
export const COD_PAIS_CL: string = 'CL';
